import {Breadcrumbs, FormDialog, Title} from '@management-ui/core';
import {Add} from '@mui/icons-material';
import {Box, Button} from '@mui/material';
import {reverse} from 'named-urls';
import {useCallback, useState} from 'react';
import * as React from 'react';
import {useHistory} from 'react-router-dom';
import TableHolder from '../../../../components/TableHolder';
import routes from '../../../../routes';
import MaterialForm from '../../forms/MaterialForm';
import Table from './Table';

const Materials = ({archive = false}) => {
  const history = useHistory();
  const [showNew, setShowNew] = useState(false);

  const goToDetail = useCallback((material) => {
    history.push(reverse(material.archived ? routes.archive.material.detail : routes.materials.detail, {id: material.id}));
  }, [history]);

  return (
    <div>
      <Breadcrumbs crumbs={[{title: 'Materials'}]}/>
      <Title title="Materials">
        <Box display="flex" flex={1} justifyContent="flex-end">
          <Button variant="contained" startIcon={<Add/>} onClick={() => setShowNew(true)} color="success">
            Add New Material
          </Button>
        </Box>
      </Title>
      <TableHolder>
        <Table archive={archive}/>
      </TableHolder>
      <FormDialog
        title="Add New Material"
        open={showNew}
        onClose={() => setShowNew(false)}
        maxWidth="sm"
        render={(props) => (
          <MaterialForm
            {...props}
            material={{}}
            onSaved={goToDetail}/>
        )}
      />
    </div>
  );
}

export default Materials;
